{
  "title": "Assignments",
  "status": {
    "pending": "Pending",
    "in_progress": "In progress",
    "submitted": "Submitted",
    "evaluated": "Evaluated",
    "revoked": "Revoked"
  },
  "table": {
    "respondent": "Respondent",
    "status": "Status",
    "brief": "Brief",
    "sent": "Sent",
    "requester": "Requested by",
    "lastReminder": "Last reminder",
    "actions": "Actions",
    "empty": "No assignments found.",
    "self": "Self-profile"
  },
  "filters": {
    "allStatuses": "All statuses",
    "respondentPlaceholder": "Search by respondent email",
    "allBriefs": "All briefs"
  },
  "actions": {
    "view": "View",
    "remind": "Send reminder",
    "remindLockout": "A reminder went out in the last 24 hours — try again later.",
    "reminded": "Reminder sent",
    "revoke": "Revoke",
    "revokeConfirmTitle": "Revoke this assignment?",
    "revokeConfirmDescription": "The invitation for {{email}} stops working immediately. This cannot be undone.",
    "revoked": "Assignment revoked"
  },
  "detail": {
    "title": "Assignment details",
    "respondent": "Respondent",
    "requester": "Requested by",
    "language": "Language",
    "sent": "Sent",
    "submitted": "Submitted",
    "lastReminder": "Last reminder",
    "personalMessage": "Personal message",
    "brief": "Brief",
    "selfAssignment": "Self-profile"
  },
  "send": {
    "title": "Send assignments",
    "description": "Invite one or more people by email to complete a profile.",
    "collapse": "Collapse",
    "expand": "Expand",
    "emails": "Email addresses",
    "emailsHelp": "Separate multiple addresses with commas or new lines.",
    "validCount_one": "{{count}} valid address",
    "validCount_other": "{{count}} valid addresses",
    "invalidList": "Ignored as invalid: {{list}}",
    "locale": "Language",
    "personalMessage": "Personal message (optional)",
    "brief": "Brief (optional)",
    "briefPlaceholder": "No brief — generic evaluation",
    "briefSearch": "Search briefs",
    "briefEmpty": "No briefs found.",
    "noBrief": "No brief",
    "createBrief": "Create new brief…",
    "submit_one": "Send {{count}} invitation",
    "submit_other": "Send {{count}} invitations",
    "submitEmpty": "Send invitations",
    "success": "Invitations sent"
  },
  "evaluations": {
    "title": "Evaluations",
    "empty": "No evaluations yet.",
    "respondent": "Respondent",
    "brief": "Brief",
    "submitted": "Submitted",
    "view": "View evaluation",
    "matrix": "Matrix",
    "evaluation": "Evaluation",
    "publishedAt": "Published",
    "notEvaluated": "This assignment has not been evaluated yet.",
    "back": "Back to evaluations",
    "notFound": "Evaluation not found."
  },
  "dashboard": {
    "sendTitle": "Send assignments",
    "sendDescription": "Invite people by email to complete their profile for this workspace.",
    "sendCta": "Go to assignments",
    "selfTitle": "Profile yourself",
    "selfDescription": "Answer the questionnaire yourself and see your own matrix.",
    "selfCta": "Start your profile",
    "recentTitle": "Recent assignments",
    "recentEmpty": "Nothing sent yet.",
    "viewAll": "View all"
  },
  "consent": {
    "self": "By beginning, you ask us to start immediately and you give up your 14-day right to withdraw this profiling once it starts.",
    "send": "By sending, you ask us to start immediately and you give up your 14-day right to withdraw this profiling once it starts."
  }
}
